import React     from 'react';
import PropTypes from 'prop-types';
import {getCurrencySymbol} from '../../../utils/CommonUtils.js';

class DiscountLabel extends React.Component {

	/**
	 * @returns {string}
	 */
	getCurrencySign() {
		switch (this.props.currency.toUpperCase()) {
			case 'EUR':
                return getCurrencySymbol();

			case 'USD':
				return '$';

			default:
				return this.props.currency.toUpperCase();
		}
	}

	getFormattedPrice(price) {
		let priceString = price.toFixed(2);
		priceString     = priceString.toString();

		priceString = priceString.replace('.', ',');

		return priceString + ' ' + this.getCurrencySign();
	}

	getDiscountPriceTag() {
		return <span className="video-grid__item--label --discount"><span className="h-text-strike h-color-fg">{this.getFormattedPrice(this.props.price)}</span> {this.getFormattedPrice(this.props.processedPrice)}</span>;
	}

	render() {
		if (this.props.price === 0 || this.props.processedPrice === 0.0) {
			return null;
		}

		return this.getDiscountPriceTag();
	}
}

DiscountLabel.propTypes = {
	currency:       PropTypes.string,
	discount:       PropTypes.number,
	price:          PropTypes.number,
	processedPrice: PropTypes.number,
};


export default DiscountLabel;
